import { render, staticRenderFns } from "./LoginComp.vue?vue&type=template&id=27ae1046&scoped=true&"
import script from "./LoginComp.vue?vue&type=script&lang=ts&"
export * from "./LoginComp.vue?vue&type=script&lang=ts&"
import style0 from "./LoginComp.vue?vue&type=style&index=0&id=27ae1046&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27ae1046",
  null
  
)

export default component.exports